import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { useSession } from "@/session/SessionProvider";

import { warmAuthenticatedAppData, warmPublicAppData } from "./prefetch";

type IdleWindow = Window & {
  requestIdleCallback?: (
    callback: () => void,
    options?: { timeout: number },
  ) => number;
  cancelIdleCallback?: (handle: number) => void;
};

export function AppPreloader() {
  const queryClient = useQueryClient();
  const { loading, session } = useSession();

  useEffect(
    () =>
      onIdle(() => {
        void warmPublicAppData(queryClient);
      }),
    [queryClient],
  );

  useEffect(() => {
    if (loading || !session) return;
    return onIdle(() => {
      void warmAuthenticatedAppData(queryClient, session);
    });
  }, [loading, queryClient, session]);

  return null;
}

function onIdle(callback: () => void) {
  const idleWindow = window as IdleWindow;
  if (idleWindow.requestIdleCallback) {
    const handle = idleWindow.requestIdleCallback(callback, { timeout: 600 });
    return () => idleWindow.cancelIdleCallback?.(handle);
  }
  const handle = window.setTimeout(callback, 250);
  return () => window.clearTimeout(handle);
}
